
import React from 'react';
import { Link } from 'react-router-dom';

export default function Index(props) {

    const styleColumns = () => {
        if (props.columns === 1)
            return 'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 g-3';
        if (props.columns === 2)
            return 'col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 g-3';
        if (props.columns === 3)
            return 'col-sm-12 col-md-12 col-lg-12 col-xl-4 g-3';
        if (props.columns === 4)
            return 'col-sm-12 col-md-12 col-lg-6 col-xl-3 g-3';
        if (props.columns === 6)
            return 'col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2 col-xxl-2 g-3';
        if (props.columns === 12)
            return 'col-12';

        return 'col-12';
    };

    return (
        <div key={props.item.id} className={styleColumns()}>
            <Link to={`/product-detail/${props.item.id}`} style={{ textDecoration: 'none' }}>
                <div className='item-offert'>
                    <img src={props.item.images[0]} alt="" />
                    <div className="item-offert-price">
                        S/. {props.item.price.toFixed(2)}
                    </div>
                    {
                        props.item.freeShipping ?
                            <div className="item-offert-free">
                                Envío gratis
                            </div> : null
                    }
                    <div className='item-offert-label'>
                        {props.item.name}
                    </div>
                </div>
            </Link>
        </div>
    );
}